import { ResourcesManager, ResourceType, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import { Euler, Mesh, MeshBasicMaterial, Quaternion, Sphere, SphereGeometry, Vector3 } from 'three';
import { MaterialImprovement } from '../../../utils/MaterialImprovement';
export class RedColoring extends ViewerModule {
    constructor() {
        super();
        this.drops = [];
        this.dropsMaterial = new MeshBasicMaterial({ color: 'red' });
        this.dropsGeometry = new SphereGeometry(0.03);
        this.resourcesInUse.push({
            name: 'red_coloring',
            type: ResourceType.FBX_MODEL,
            priority: 0,
            url: require('../../../../assets/models/spectrophotometer/red_coloring.fbx')
        });
        const topPoint = new Vector3(-0.001624066905275244, 0.5989710085081583, 0.03669857247766529);
        const bottomPoint = new Vector3(-0.001624066905275244, 0, 0.03669857247766529);
        // const debugPoint1 = window['debugPoint10'] = new Mesh(new SphereGeometry(0.1), new MeshBasicMaterial({color: 'green'}));
        // const debugPoint2 = window['debugPoint20'] = new Mesh(new SphereGeometry(0.1), new MeshBasicMaterial({color: 'green'}));
        // this.addObject(debugPoint1, null, this.model);
        // this.addObject(debugPoint2, null, this.model);
        // debugPoint1.position.copy(topPoint)
        // debugPoint2.position.copy(bottomPoint)
        this.onUpdateCallback = () => {
            if (this.model.localToWorld(topPoint.clone()).y <= this.model.localToWorld(bottomPoint.clone()).y) {
                let drop;
                this.drops.push(drop = new Mesh(this.dropsGeometry, this.dropsMaterial));
                Viewer.scene.add(drop);
                drop.scale.multiplyScalar(Math.random() + 0.5);
                drop.position.copy(this.model.localToWorld(topPoint.clone()));
                drop.userData.sphere = new Sphere(drop.position, 0.03 * drop.scale.x);
            }
            this.drops.slice().forEach(drop => {
                drop.position.y -= 0.05;
                if (drop.position.y < -18.9) {
                    this.removeDrop(drop);
                }
                else {
                    drop.userData.sphere.center.copy(drop.position);
                }
            });
        };
    }
    init() {
        if (this.model)
            this.removeObject(this.model);
        this.addObject(this.model = ResourcesManager.getModel('red_coloring').clone());
        MaterialImprovement.upgradeMaterialsFromModel(this.model, 'red_coloring');
    }
    reset() {
        this.init();
    }
    setDynamicLiquidMode(enabled) {
        if (enabled) {
            Viewer.on('update', this.onUpdateCallback);
        }
        else {
            this.onUpdateCallback && Viewer.off('update', this.onUpdateCallback);
            this.drops.slice().forEach(drop => {
                this.removeDrop(drop);
            });
        }
    }
    removeDrop(drop) {
        drop.parent && drop.parent.remove(drop);
        this.drops.splice(this.drops.indexOf(drop), 1);
    }
    dispose() {
        super.dispose();
        this.drops.forEach(drop => {
            drop.parent && drop.parent.remove(drop);
        });
        this.dropsGeometry.dispose();
        this.dropsMaterial.dispose();
    }
    setAsPointerControllerObject(toggle) {
        if (!this.model)
            return;
        return new Promise(resolve => {
            let newPosition, newRotation;
            if (toggle) {
                newPosition = new Vector3(0, 0.651267218650488, 0);
                newRotation = new Quaternion().setFromEuler(new Euler(0, 0, Math.PI));
            }
            else {
                newPosition = new Vector3(0, 0, 0);
                newRotation = new Quaternion().setFromEuler(new Euler(0, 0, 0));
            }
            const oldRotation = this.model.children[0].quaternion.clone(), oldPosition = this.model.children[0].position.clone();
            new TWEEN.Tween(this.model.children[0].position).to(newPosition, 1500)
                .easing(TWEEN.Easing.Quadratic.Out)
                .onUpdate((alpha) => {
                this.model.children[0].quaternion.copy(oldRotation.clone().slerp(newRotation, alpha));
            })
                .onComplete(() => {
                resolve();
            })
                .start();
        });
    }
}
